import { Toaster } from '@/components/ui/toaster';
import { system } from '@/theme';
import { ChakraProvider } from '@chakra-ui/react';
import { createInertiaApp } from '@inertiajs/react';
import { configureEcho } from '@laravel/echo-react';
import React from 'react';
import { createRoot } from 'react-dom/client';
import AmplitudeConfig from './util/logging/amplitude-config';

configureEcho({
  broadcaster: 'pusher',
  key: import.meta.env.VITE_PUSHER_APP_KEY,
  cluster: import.meta.env.VITE_PUSHER_APP_CLUSTER,
  forceTLS: true,
  authEndpoint: '/broadcasting/auth',
  auth: {
    headers: {
      'X-CSRF-TOKEN':
        document.querySelector<HTMLMetaElement>('meta[name="csrf-token"]')
          ?.content ?? '',
    },
  },
});

const pages = import.meta.glob<{ default: React.ComponentType }>(
  './pages/**/*.tsx',
);

function resolvePageComponent(name: string): Promise<React.ComponentType> {
  for (const path in pages) {
    const fileName = path.replace('./pages/', '');
    if (fileName === `${name.replace('.', '/')}.tsx`) {
      return pages[path]().then((module) => module.default);
    }
  }

  throw new Error(`Page not found: ${name}`);
}

createInertiaApp({
  resolve: (name) => resolvePageComponent(name),
  setup({ el, App, props }) {
    AmplitudeConfig();
    createRoot(el).render(
      <ChakraProvider value={system}>
        <App {...props} />
        <Toaster />
      </ChakraProvider>,
    );
  },
  progress: {
    color: '#FCAE1E',
  },
});
